import { device } from "@src/theme";
import styled from "styled-components";

export const PlaylistOverviewHeader = styled.div`
  display: flex;
  height: 130px;
  width: 100%;
`;
export const PlaylistOverviewHeaderLeft = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: space-between;
  flex-direction: column;
`;
export const PlaylistOverviewHeaderRight = styled.div`
  display: flex;
  flex: 1;
`;
export const PlaylistOverviewHeaderCenter = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  height: 130px;
  margin: 0px ${(props): string => props.theme.margins.xl};
  @media ${device.mobile} {
    display: none;
  }
  @media ${device.tablet} {
    display: none;
  }
  @media ${device.laptop} {
    display: flex;
  }
  @media ${device.desktop} {
    display: flex;
  }
`;
export const PlaylistDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: ${(props): string => props.theme.margins.medium};
`;

export const PlaylistOverviewHeaderRightContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 130px;
  color: ${({ theme }): string => theme.colors.yellow};
`;

export const ButtonSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  flex: 1;
  height: 100%;
`;

export const TopButtons = styled.div`
  display: flex;
  gap: ${(props): string => props.theme.margins.small};
`;

export const BottomButtons = styled.div`
  display: flex;
  gap: ${(props): string => props.theme.margins.small};
`;
export const BottomButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-left: ${(props): string => props.theme.margins.medium};
`;

export const ActionButton = styled.button`
  background-color: ${({ theme }): string => theme.colors.yellow};
  border: 1px solid ${({ theme }): string => theme.colors.darkGray};
  color: ${({ theme }): string => theme.colors.black};
  font-size: 1rem;
  font-weight: bold;
  width: 100px;
  height: 40px;
  border-radius: 5px;
  cursor: pointer;
`;

export const TotalLabelWrapper = styled.div`
  padding: 5px 0px;
  display: flex;
  justify-content: flex-end;
`;

export const TotalLabel = styled.span`
  font-size: 22px;
  font-weight: bold;
  color: ${({ theme }): string => theme.colors.yellow};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${device.tablet} {
    font-size: 18px;
  }
  @media ${device.laptop} {
    font-size: 20px;
  }
  @media ${device.desktop} {
    font-size: 22px;
  }
`;
export const SearchInputWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;
